// extracted by mini-css-extract-plugin
module.exports = {"Button__disabled":"_1WevSM592w-button-Button__disabled","Button__fullWidth":"_2iVkGOvXu2-button-Button__fullWidth","Button__regWidth":"_3BLLZSBimt-button-Button__regWidth"};